import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "components/shared/BackButton";
import { StyledStack, ButtonContainer, StyledTitle } from "./AddCategory.style";
import { useForm } from "react-hook-form";
import Upload from "components/shared/Upload";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckIcon from "@mui/icons-material/Check";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import ProgressBarCM from "components/shared/ProgressBar";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import { CategorySchema } from "validations";
import { addCategoryRequest } from "api/requests";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

let types = [
  { id: 1, name: "مبلمان" },
  { id: 2, name: "اکسسوری" },
];

export default function AddCategory() {
  const navigate = useNavigate();
  const { request, loading } =
    useHttp(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(CategorySchema),
  });
  const [selectedType, setSelectedType] = useState({});

  const onSubmit = async (data) => {
    const res = await request({
      url: addCategoryRequest,
      values: { ...data },
    });

    if (res) {
      Toast({ type: "success", title: "ثبت زیردسته" });
      navigate("/category");
    }
  };

  return (
    <DrawerCM title="افزودن زیردسته">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>افزودن زیردسته</StyledTitle>
            <Grid container>
              <Grid item md={6} xs={12} p={1.5}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="title"
                  {...register("title")}
                  error={Boolean(errors.title)}
                  helpertext={errors.title?.message}
                />
              </Grid>
              <Grid item md={6} xs={12} p={1.5}>
                <FormControl fullWidth>
                  <InputLabel id="select-type">سردسته</InputLabel>
                  <Select
                    labelId="select-type"
                    label="سردسته"
                    value={selectedType?.name}
                    // defaultValue={userData?.type}
                    id="type"
                    {...register("type")}
                    error={Boolean(errors.type)}
                    helpertext={errors.type?.message}
                    onChange={(e) =>
                      setSelectedType({
                        name: e.target.value,
                      })
                    }
                  >
                    {types?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item.name}
                        style={{
                          direction: "rtl",
                        }}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
